import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box, Typography } from "@mui/material";
import { useMyHrEmployee } from "my-hr/hooks";
import { OcDataTableBodyCellState } from "oc/components";
import { getFullname } from "oc/utils";

interface MyTimesheetRequest {
  state?: "approved" | "rejected" | string;
  approvedBy?: string;
  rejectedBy?: string;
  approvedAt?: string | Date;
  rejectedAt?: string | Date;
  createdAt?: string | Date;
  // add other fields as needed
}

interface MyTimesheetShowRequestDialogStateDataProps {
  request: MyTimesheetRequest;
  isMobile?: boolean;
}

export const MyTimesheetShowRequestDialogStateData = ({
  request,
  isMobile,
}: MyTimesheetShowRequestDialogStateDataProps) => {
  const { data: approvedCode } = useMyHrEmployee({
    employeeId: request?.approvedBy ?? "",
  });
  const { data: rejectedCode } = useMyHrEmployee({
    employeeId: request?.rejectedBy ?? "",
  });

  const { t } = useTranslation();

  const getFormattedDate = () => {
    switch (request?.state) {
      case "approved":
        return moment(request?.approvedAt).format("YYYY.MM.DD HH:mm");
      case "rejected":
        return moment(request?.rejectedAt).format("YYYY.MM.DD HH:mm");
      default:
        return moment(request?.createdAt).format("YYYY.MM.DD HH:mm");
    }
  };

  return (
    <Box
      width={isMobile ? "100%" : "200px"}
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="flex-end"
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Typography
          style={{
            fontSize: "10px",
            lineHeight: "normal",
            fontWeight: 300,
            color: "#919699",
          }}
        >
          {getFormattedDate()}
        </Typography>
        <Box height="2px" />
        {request?.state === "approved" && (
          <Box fontSize="9px" style={{ color: "#919699" }}>
            {getFullname(approvedCode)}
          </Box>
        )}
        {request?.state === "rejected" && (
          <Box fontSize="9px" style={{ color: "#919699" }}>
            {getFullname(rejectedCode)}
          </Box>
        )}
        <Box height="2px" />

        <OcDataTableBodyCellState label={t(request.state!)} />
      </Box>
    </Box>
  );
};

export default MyTimesheetShowRequestDialogStateData;
